import React, { useEffect, useState } from 'react'
import { useTranslation } from 'i18n'
const LocationCountBlurb = ({ locationInfo, formTouched }) => {
  const { t } = useTranslation('locator')
  const [blurb, setBlurb] = useState('')
  const changeTheBlurb = () => {
    if (formTouched === true) {
      if (locationInfo.length > 0) {
        setBlurb(``)
      } else {
        setBlurb(t('noStoresFound'))
      }
    } else {
      if (locationInfo.length > 0) {
        setBlurb(``) //if we start dragging before entering a zip
      } else {
        setBlurb(t('enterZipPrompt'))
      }
    }
  }

  useEffect(() => {
    changeTheBlurb()
  }, [locationInfo])

  return <>{blurb && <div className="locator--blurb-container">{blurb}</div>}</>
}
export default LocationCountBlurb
